import { TranslationsInputTextController } from "./translations-input-text.controller";

angular
    .module("thor.shared.translations.translations-input-text.component", [])
    .component("translationsInputText", {
        bindings: {
            rows: "<",
            cols: "<",
            noAutoGrow: "<",
            model: "=",
            saveStandard: "&",
            saveTranslation: "&",
            disabled: "<",
            required: "<",
            name: "@",
            translationField: "@",
            field: "@",
            selectedLang: "<",
            sourceLang: "<",
            patternInputText: "<",
            autoFocus: "<",
            onStandardKeyUp: "&",
            onTranslationKeyUp: "&"
        },
        controller: TranslationsInputTextController,
        template: require("../../shared/translations/translations-input-text.html")
    });
